import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { GameScene } from './scenes/GameScene';
import { CardZoomScene } from './scenes/CardZoomScene';
import { GameOverScene } from './scenes/GameOverScene';

export const COLORS = {
  bg: 0x0d1117,
  panel: 0x161b22,
  card: 0x1f2937,
  cardAffordable: 0x166534,
  cardAcquired: 0x4b5563,
  cardAdjacent: 0x1e3a8a,
  white: 0xf3f4f6,
  red: 0xef4444,
  blue: 0x60a5fa,
  text: 0xe6edf3,
  textMuted: 0x9ca3af,
  accent: 0xfbbf24,
  border: 0x30363d,
};

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#0d1117',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 400,
    height: 800,
  },
  scene: [BootScene, MenuScene, GameScene, CardZoomScene, GameOverScene],
});

(window as unknown as { game: Phaser.Game }).game = game;
